import { render, staticRenderFns } from "./UploadFileContract2024.vue?vue&type=template&id=011b2f6a&scoped=true"
import script from "./UploadFileContract2024.vue?vue&type=script&lang=js"
export * from "./UploadFileContract2024.vue?vue&type=script&lang=js"
import style0 from "./UploadFileContract2024.vue?vue&type=style&index=0&id=011b2f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b2f6a",
  null
  
)

export default component.exports